/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require("./bootstrap");
window.Vapor = require('laravel-vapor');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import React from "react";
import ReactDOM from "react-dom";
import App from "./React/App";
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
    apiKey: '9e7e5749ffffa74ff30c289e272fe31d',
    plugins: [new BugsnagPluginReact()],
    releaseStage: window.env
});

const ErrorBoundary = Bugsnag.getPlugin('react')
    .createErrorBoundary(React);

ReactDOM.render(
    <ErrorBoundary>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </ErrorBoundary>,
    document.getElementById("root")
);
